import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  baseUrl: string = environment.baseUrl;
  apiUrl: string = environment.baseUrl + '/api/v1/webmaster';
  apiUrlV2: string = environment.baseUrl + '/webmaster/api/v1'
  galleryUrl: string = environment.galleryUrl;
  profile: any = {};
  draft: any = {};
  token: string = null;
  loading: boolean = false;
  tutorials = [];

  constructor(
    private _toast: MessageService,
    private _http: HttpClient,
    private _router: Router
  ) {
    console.log('Servicio global, creado');
  }
  
  setProfile(profile){
    this.profile = profile;
    this.setStorage('profile',JSON.stringify(this.profile));
  }

  setToken(token){
    this.token = token;
    this.setStorage('token', this.token);
  }

  getPermission(permission_id: number): boolean{
    return this.profile.permission.includes(permission_id);
  }

  formatNumber(num) {
    return parseFloat(num).toFixed(2).toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }

  headersBuilder(auth?: boolean, body?: any, formdata?: boolean) {
    let headers

    if(auth)
      if(formdata){
        headers = new HttpHeaders({
          'Authorization': `${ this.token }`
        })
      }else{
        headers = new HttpHeaders({
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `${ this.token }`
        })
      }  

    else
      headers = new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8',
      })


    let requestOptions;

    if(body)
      requestOptions = {
        headers: headers,
        body: body,
      }

    else
      requestOptions = {
        headers: headers,
        //reportProgress: true,
      }

    return requestOptions;
  }

  setStorage(key: string, value: any) {
    try {
      localStorage.setItem(key, value)
    }
    catch(e) { }
  }

  getStorage(key: string) {
    try {
      return localStorage.getItem(key)
    }
    catch(e) { }
  }

  removeStorage(key: string, all?: boolean) {
    try {
      all ? localStorage.clear() : localStorage.removeItem(key)
    }
    catch(e) { }
  }

  createToast(type = 'info', title, content?){
    this._toast.add(
      {
        severity: type, 
        summary: title, 
        detail: content
      }
    );
  }

  logout() {
    this.profile = false
    this.token = null;
    this.removeStorage(null, true)
  }

  navigate(url){
    this._router.navigateByUrl(url);
  }

  //HTTP REQUEST!

  ping(): Observable<any>{
    let options = this.headersBuilder(true);
    return this._http.get(`${this.apiUrl}/admin/ping`, options);
  }

  login(form):Observable<any>{
    form = JSON.stringify(form)
    let options = this.headersBuilder(false, form)
    return this._http.post(`${ this.apiUrl }/admin/signin`, form, options)
  }

  register(form):Observable<any>{
    form = JSON.stringify(form)
    let options = this.headersBuilder(false, form)
    return this._http.post(`${ this.apiUrl }/admin/signup`, form, options)
  }

  passwordRecovery(form) {
    form = JSON.stringify(form)
    let options = this.headersBuilder(true, form)
    return this._http.post(`${ this.apiUrl }/admin/password/recovery`, form, options)
  }

  passwordUpdate(form) {
    form = JSON.stringify(form)
    let options = this.headersBuilder(true, form)
    return this._http.post(`${ this.apiUrl }/admin/password/update`, form, options)
  }

  //

}
